import { useQuery } from '@tanstack/react-query';
import {
  fetchProductionDashboardStats,
  fetchProductionMaterialSummary,
  fetchProductionMaterialBreakdown,
  fetchProductionMaterialTotals,
  fetchRemainingMaterialSummary,
  fetchFinalPhaseTokens
} from '../api/jobsApi';

export function useProductionDashboardStats() {
  return useQuery({
    queryKey: ['production-dashboard-stats'],
    queryFn: fetchProductionDashboardStats,
    refetchInterval: 10000
  });
}

export function useProductionMaterialSummary() {
  return useQuery({
    queryKey: ['production-dashboard', 'material-summary'],
    queryFn: fetchProductionMaterialSummary,
    refetchInterval: 10000,
    staleTime: 5000
  });
}

/**
 * The drill-down behind a material bar. Disabled until something is asked for,
 * so opening the dashboard does not fetch a breakdown nobody has clicked.
 */
export function useProductionMaterialBreakdown(keys = []) {
  const list = (Array.isArray(keys) ? keys : [keys]).filter(Boolean);
  return useQuery({
    queryKey: ['production-dashboard', 'material-breakdown', [...list].sort().join('|')],
    queryFn: () => fetchProductionMaterialBreakdown(list),
    enabled: list.length > 0,
    // Slower than the chart: this is read, not watched, and a table that
    // reorders under the cursor every ten seconds cannot be read at all.
    refetchInterval: 30000,
    staleTime: 15000
  });
}

export function useProductionMaterialTotals() {
  return useQuery({
    queryKey: ['production-dashboard', 'material-totals'],
    queryFn: fetchProductionMaterialTotals,
    refetchInterval: 10000,
    staleTime: 5000
  });
}

export function useRemainingMaterialSummary() {
  return useQuery({
    queryKey: ['orders', 'remaining-material-summary'],
    queryFn: fetchRemainingMaterialSummary,
    refetchInterval: 10000,
    staleTime: 5000
  });
}

export function useFinalPhaseTokens() {
  return useQuery({
    queryKey: ['production-dashboard', 'final-phase-tokens'],
    queryFn: fetchFinalPhaseTokens,
    refetchInterval: 5000,
    staleTime: 3000
  });
}
